import { Menu } from "antd";

const SidebarNavMenu = (props) => <Menu {...props} />;

export default SidebarNavMenu;
